export const ordersReportName = {
  clubOrderSystemReport: 'Club Order System Report',
  compOrderSystemReport: 'Comp Order System Report',
  putterOrderSystemReport: 'Putter Order System Report',
} as const;
